module.exports = __webpack_public_path__ + "img/poster-4.f7186e77.jpg";